module.exports = vendor_60fcb2b013da6fbbba66;


//////////////////
// WEBPACK FOOTER
// external "vendor_60fcb2b013da6fbbba66"
// module id = 3
// module chunks = 10